"use client";

import React, { useState } from "react";
import { Separator } from "@/components/ui/separator";
const faqs = [{
  q: "話した内容はすべて秘密にしてもらえますか？プライバシーは守られますか？",
  a: "カウンセリングは話した内容に関して秘密厳守が原則です。カウンセラーが内容を勝手に公開することはありませんのでご安心ください。"
}, {
  q: "家族やパートナーに知られずにカウンセリングを受けることはできますか？",
  a: "秘密厳守と関連しますが、たとえご家族からの問い合わせであってもご相談の有無についてお答えはしませんので、誰にも知られずにカウンセリングを行うことができます。"
}, {
  q: "どんな悩みや症状でもカウンセリングで対応してもらえますか？",
  a: "カウンセリングでは抱えている問題を心理的な側面から話し合っていきます。そのため多くの悩みや症状についてご相談いただけますが、具体的な内容や求める解決法によっては他の相談先をお勧めすることもあると思います。"
}, {
  q: "1回のカウンセリングの時間はどのくらいですか？",
  a: "カウンセリングは1回50分が基本になります。"
}, {
  q: "カウンセリングはどのくらいの頻度で、どのくらいの期間受けるのが一般的ですか？",
  a: "当相談室では週1回をお勧めすることが多いですが、週複数回や隔週などの頻度でも行っています。期間は1回で終える方もいれば数年続ける方もおり、人によって大きく異なります。"
}, {
  q: "カウンセリングの費用はいくらくらいですか？",
  a: "カウンセリング費用は、お一人の場合は1回8,000円、複数人の場合は10,000円（いずれも税込）になります。"
}, {
  q: "キャンセル費用はかかりますか？",
  a: "ご予約日の7日前以降にキャンセルされた場合は、料金の全額をキャンセル料として頂戴しています。"
}, {
  q: "カウンセリングを受けるのに、精神疾患の診断は必要ですか？",
  a: "診断がなくてもカウンセリングは受けられます。ただ通院されている場合は治療方針などあると思いますので、カウンセリングの可否を主治医にご確認いただくことをお勧めします。"
}, {
  q: "医療機関（精神科や心療内科）での治療とカウンセリングはどう違いますか？",
  a: "医療機関での診療は時間的な制約もあり薬物療法が中心になることが多いです。カウンセリングでは時間をかけて話すことを通して抱えている問題に取り組んでいきます。"
}, {
  q: "話したくないこと、うまく話せないことがあっても大丈夫ですか？",
  a: "カウンセリングでは話すべきことが常に明確であるとは限りません。話したくなければ無理に話すことはないですし、うまく伝えられないことはカウンセラーと一緒に少しずつ言葉にしていきましょう。"
}, {
  q: "カウンセリング中に感情的になってしまっても大丈夫ですか？",
  a: "カウンセリングでのやりとりでは感情も重要な要素です。感情が高ぶった時には無理に抑えずとも大丈夫です。"
}, {
  q: "子どもや家族と一緒にカウンセリングを受けることはできますか？",
  a: "ご家族で一緒になど複数人でカウンセリングを行うことも可能です。ただ、一人で続けてきて途中からどなたかをお連れする際はカウンセラーにお伝えください。"
}, {
  q: "初回面接では何を話しますか？",
  a: "ご相談内容・成育歴・家族歴・カウンセリングで期待することなどについてお聞きします。その後、ご相談者様についてのカウンセラーの見立てをお伝えし、当ルームでできることをご提案します。"
}, {
  q: "アセスメント面接とは何ですか？",
  a: "初回面接で話しきれなかったことを話し合い、より詳細な見立てや今後のことについて検討する面接です。回数は人によって異なりますが、およそ3〜5回程度です。面接の最後にカウンセラーより見立てや今後取り組んでいくことについてご報告します。"
}, {
  q: "カウンセリング終了後もサポートはありますか？",
  a: "はい、フォローアップ面接を設定することができます。カウンセリング終了後3〜6ヶ月が経過したタイミングで、その時点での状況やカウンセリングでの達成についてお話しします。"
}];
export default function FrequentlyAskedQuestions() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="frequently-asked-questions" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">

        <div className="mb-10">
          <h1 className="text-3xl md:text-4xl font-bold text-primary font-default leading-tight mb-4">よくあるご質問</h1>
          <Separator className="w-12 h-0.5 bg-primary mb-8" />
          <p className="text-foreground leading-relaxed font-default">新宿四谷心理カウンセリングルームに、実際によくお寄せいただくご質問をまとめました。料金や秘密の扱い、医療機関との違いなど、初めてカウンセリングを検討される方が気になる点を中心にお答えしています。</p>
        </div>

        <div className="border-t border-border">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} data-index={i} className="border-b border-border">
                <h2 className="m-0">
                  <button type="button" id={`faq-question-${i}`} aria-expanded={isOpen} aria-controls={`faq-answer-${i}`} onClick={() => setOpenIndex(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 py-5 text-left font-default text-base md:text-lg font-bold text-foreground">
                    <span className="flex-1">{faq.q}</span>
                    <svg className={`size-5 shrink-0 text-primary transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </button>
                </h2>

                {/* 常にDOMに存在させ、高さだけをCSSで制御する */}
                <div id={`faq-answer-${i}`} role="region" aria-labelledby={`faq-question-${i}`} className={`overflow-hidden transition-all duration-300 ease-out ${isOpen ? "max-h-[800px] opacity-100" : "max-h-0 opacity-0"}`}>
                  <p className="font-default text-foreground leading-relaxed pb-6">{faq.a}</p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}